export const onEnterOrEscapeKeyDown = (event: React.KeyboardEvent) => {
  event.stopPropagation();
  return event.key === 'Enter' || event.key === 'Escape'
    ? (event.target as HTMLElement).click()
    : null;
};

export const stopPropagationAccessibilityBehavior = (
  event: React.KeyboardEvent,
) => {
  if (event.key === 'Tab') {
    event.stopPropagation();
  }
};
